import type { EditorThemeClasses } from "lexical"

const editorTheme: EditorThemeClasses = {
  text: {
    underline: "LexicalEditor__underline",
    bold: "LexicalEditor__bold",
    italic: "LexicalEditor__italic",
  },
  link: "LexicalEditor__link",
  image: "LexicalEditor__image",
  list: {
    listitem: "LexicalEditor__listItem",
    listitemChecked: "LexicalEditor__listItemChecked",
    listitemUnchecked: "LexicalEditor__listItemUnchecked",
    nested: {
      listitem: "LexicalEditor__nestedListItem",
    },
    olDepth: [
      "LexicalEditor__ol1",
      "LexicalEditor__ol2",
      "LexicalEditor__ol3",
      "LexicalEditor__ol4",
      "LexicalEditor__ol5",
    ],
    ul: "LexicalEditor__ul",
  },
  table: "LexicalEditor__table",
  tableAddColumns: "LexicalEditor__tableAddColumns",
  tableAddRows: "LexicalEditor__tableAddRows",
  tableAlignment: {
    center: "LexicalEditor__tableAlignmentCenter",
    right: "LexicalEditor__tableAlignmentRight",
  },
  tableCell: "LexicalEditor__tableCell",
  tableCellActionButton: "LexicalEditor__tableCellActionButton",
  tableCellActionButtonContainer: "LexicalEditor__tableCellActionButtonContainer",
  tableCellHeader: "LexicalEditor__tableCellHeader",
  tableCellResizer: "LexicalEditor__tableCellResizer",
  tableCellSelected: "LexicalEditor__tableCellSelected",
  tableScrollableWrapper: "LexicalEditor__tableScrollableWrapper",
  tableSelected: "LexicalEditor__tableSelected",
  tableSelection: "LexicalEditor__tableSelection",
}

export default editorTheme
